/* eslint-disable n/no-unsupported-features/node-builtins -- this is a browser environment */
import axios from 'axios'
import { useRequestHeader } from '@dhl/axios'
import { getXsrfTokenFromCookie } from '@dhl/receiver-axios'
import { localStorageLocale } from './i18n'

export const instance = () =>
  axios.create({
    headers: {
      'X-XSRF-TOKEN': getXsrfTokenFromCookie(),
      'X-LANG': localStorage.getItem(localStorageLocale) || '',
      'X-VERSION': 'latest',
      'X-REQUESTED-WITH': 'account-app',
    },
  })

// Read at request time; a render-time value goes stale after a language switch
const getLanguage = () => localStorage.getItem(localStorageLocale) || ''

export function useSetupRequestInterceptor() {
  useRequestHeader('X-LANG', getLanguage)
  useRequestHeader('X-REQUESTED-WITH', 'account-app')
  useRequestHeader('X-VERSION', 'latest')
}
